import React from 'react';
import './header-component.scss';
import { Constants, ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import { Link, Redirect } from 'react-router-dom';
import Path from '../../routes/routes-path';
import Loading from '../../common/loading/loading';
import Service from '../../../apis/service-manager';
import Urls from '../../../apis/url';
import SessionCache from '../../routes/session-cache';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRetweet } from '@fortawesome/free-solid-svg-icons'
import RewardApi from '../../../apis/rewards'
import Store from '../../../store/store';
import CommonUtils from '../../../utility/common-utilities';
import IndexedDBHelperV2 from '../../../offline/apis/indexDBManager-v2';
import ReactTooltip from 'react-tooltip';
import ArchiveComponent from '../cw-confirmation-modal/cw-confirmation-modal';
const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);


class Header extends React.Component {

    state = {
        isLogout: false,
        isLoading: false,
        userInfo: {},
        showCloseAppConfirmationPopup: false
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })
        this.getReward()
        Store.setStore("headerComponent", this)
    }

    getReward(payload = {}) {
        RewardApi.getRewardPoints(payload)
            .then(response => {
                let reward = response.response
                this.setState({ reward: reward, isLoading: false })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    logout = () => {

        this.setState({
            isLoading: true
        });

        let cookieItem = { hash: 'session', value: "" }
        dbHelper.updateData(Constants.COOKIE_STORE, cookieItem).then((id) => {
            Service.createData(Urls.LOGOUT, {}, (err, res) => {
                SessionCache.setUser({
                    isAuthenticated: false
                });

                this.setState({
                    isLoading: false,
                });

                setTimeout(() => {
                    this.setState({
                        isLogout: true,
                    });
                }, 200);
            })
        }).catch(err => {
            console.log(err)
        })


    }

    showCloseAppPopup() {
        this.setState({ showCloseAppConfirmationPopup: true })
    }

    closeElectronApp() {
        if (window.electron) {
            window.electron.ipcRenderer.send('close-app', ['ping'])
        }
    }


    hideCloseAppPopup() {
        this.setState({ showCloseAppConfirmationPopup: false })
    }

    render() {

        return (
            <div className={`cw-header row no-gutters ${this.props.transparent ? '' : 'bg-white'}`}
                style={{ display: `${this.props.showHideHeader ? "" : "none"}` }}>
                {this.state.isLoading && <Loading></Loading>}
                {this.state.isLogout && <Redirect to={Path.LOGIN} />}

                <div className="col logo-container">
                    <Link to={Path.DASHBOARD}>
                        <img className="logo" src={getImageSource(ImageConstants.CW_LOGO)} />
                    </Link>
                </div>
                <div className='col-2 subject-text-padding d-flex align-items-center' onMouseEnter={ReactTooltip.rebuild}>{this.state?.userInfo?.subjectName || ""}
                    {
                        this.state?.userInfo?.subjects && this.state?.userInfo?.subjects.length > 1 ?
                            <Link to={Path.SUBJECT_SELECTION} className="ml-1" data-tip={"Change Subject"}>
                                <FontAwesomeIcon className="cursor-pointer" icon={faRetweet} />
                            </Link>
                            :
                            <></>
                    }

                </div>
                <div className="col header-right-container" onMouseEnter={ReactTooltip.rebuild}>
                    {/* <Link to={`${Path.PROFILE}?type=reward`}>
                        <div className="d-inline-block reward-wrapper mr-4">
                            <img alt="" src={getImageSource(ImageConstants.GIFTBOX)} className='mr-2' />
                            <span className="reward-text mr-2">My Reward Points</span> <span className="reward-point"> {CommonUtils.convertToFixed(this.state.reward?.availablePoints || 0, 2)}</span>
                        </div>
                    </Link> */}

                    {!this.props.from || this.props.from != 'VERIFY_SCREEN' ? <><div className='school-container'>
                        <div className='text-left'><span className='school-name'>{this.state?.userInfo?.schoolInfo?.name || ""}</span></div>
                        <div className='text-left school-address'>{this.state?.userInfo?.schoolInfo?.address?.branch || ""}, {this.state?.userInfo?.schoolInfo?.address?.city || ""}</div>
                    </div>
                        {
                            this.state.userInfo?.isSuperAdmin ?
                                <div className='school-container'>
                                    <div className='text-right'>
                                        <Link to={Path.SCHOOLS}>
                                            <FontAwesomeIcon className="cursor-pointer" icon={faRetweet} />
                                        </Link>
                                    </div>
                                </div> : ""
                        }
                        <div className='school-container'>
                            <div className='text-left'><small className=''>    </small>   <span className='school-name'>{this.state?.userInfo?.name || ""}</span></div>
                            <div className='text-left'><small></small> <span className='school-name'>{this.state?.userInfo?.schoolInfo?.schoolCode || ""}</span></div>
                            {/* <div className='text-right mr-2'><small className=''>SUBJECT :</small> <span className='school-name'>{this.state?.userInfo?.subjectName || ""}</span></div> */}
                            <div className='text-left version-margin'><small></small> <span className='school-name'>{Constants.ELECTRON_VERSION}</span>,
                                <span className='school-name'>{CommonUtils.isOnline() ? "Online" : 'Offline'}</span></div>
                        </div>

                        {/* <div className='school-container'>
                            <div className='text-right'><small>SUB :</small> <span className='school-name'>{this.state?.userInfo?.subjectName || ""}</span></div>
                        </div> */}

                        {/* <div className='pr-5'>
                            <img className='bell-icon' src={getImageSource(ImageConstants.NOTIFICATION_BELL_ACTIVE)}></img>
                        </div> */}
                    </> : ''}
                    {this.props.from && this.props.from == 'VERIFY_SCREEN' ? <span className='pr-2 logout-text'>Logout</span> : ''}
                    <img className="text-icon pt-2 pb-2" src={getImageSource(ImageConstants.LOGOUT_RED)}
                        data-tip={"Logout"}
                        onClick={this.logout}></img>
                    {
                        Constants.ELECTRON_BUILD ?
                            <img className="close-icon ml-2 cursor-pointer"
                                onClick={() => this.showCloseAppPopup()}
                                // data-tip={"Close App"}
                                src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                            :
                            <></>
                    }
                </div>
                {
                    this.state.showCloseAppConfirmationPopup ? <ArchiveComponent message={'Do You Want to Close the Countingwell Application'}
                        onOk={() => this.closeElectronApp()}
                        close={() => this.hideCloseAppPopup()} /> : ""
                }
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>
        );
    }
}

export default Header;